declare global {
  interface Window {
    // facebook pixel
    fbq: (
      command: 'track' | 'init' | 'trackCustom',
      event: string,
      data?: unknown,
      options?: { eventID: string },
    ) => void
  }
}

type TimerBasedTrackingEventType =
  | 'Signup Page #page1'
  | 'Signup Page #page2'
  | 'Signup Page #page3'
  | 'Mobile CTA'

type ScrollTracker = {
  maxScrollPercent: number
  cleanup: () => void
}

function initializeScrollTracking(): ScrollTracker {
  let maxScrollPercent = 0

  const scrollListener = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const scrollHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight
    const scrollPercent = Math.round((scrollTop / scrollHeight) * 100)
    maxScrollPercent = Math.max(maxScrollPercent, scrollPercent)
  }

  window.addEventListener('scroll', scrollListener)

  return {
    get maxScrollPercent() {
      return maxScrollPercent
    },
    cleanup: () => window.removeEventListener('scroll', scrollListener),
  }
}

function trackMetaTimerBasedPageView(
  pageName: TimerBasedTrackingEventType,
  scrollPercent: number,
  eventID: string,
) {
  window.fbq('trackCustom', pageName, { value: scrollPercent }, { eventID })
}

export function trackAfterDuration(
  pageName: TimerBasedTrackingEventType,
  eventID: string,
  minDuration = 3000,
) {
  const scrollTracker = initializeScrollTracking()
  let hasTracked = false

  setTimeout(async () => {
    if (hasTracked) {
      return
    }

    trackMetaTimerBasedPageView(
      pageName,
      scrollTracker.maxScrollPercent,
      eventID,
    )
    hasTracked = true
    scrollTracker.cleanup()
  }, minDuration)
}
